import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { ProductsAPI, MovementsAPI, StatsAPI } from "../lib/api";
import { setBadge } from "../lib/pwa";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [lowStock, setLowStock] = useState([]);
  const [stats, setStats] = useState({
    total_products: 0,
    in_esaurimento: 0,
    esauriti: 0,
    totale_giacenza: 0,
  });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [p, s, l] = await Promise.all([
        ProductsAPI.list(),
        StatsAPI.get(),
        StatsAPI.lowStock(),
      ]);
      setProducts(p);
      setStats(s);
      setLowStock(l);
      const alerts = (s?.in_esaurimento || 0) + (s?.esauriti || 0);
      setBadge(alerts);
    } catch (e) {
      console.error("refresh failed", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const createProduct = async (data) => {
    await ProductsAPI.create(data);
    await refresh();
  };
  const updateProduct = async (id, data) => {
    await ProductsAPI.update(id, data);
    await refresh();
  };
  const removeProduct = async (id) => {
    await ProductsAPI.remove(id);
    await refresh();
  };
  const registerMovement = async (data) => {
    const mv = await MovementsAPI.create(data);
    await refresh();
    return mv;
  };
  const removeMovement = async (id) => {
    await MovementsAPI.remove(id);
    await refresh();
  };

  const value = {
    products,
    lowStock,
    stats,
    loading,
    refresh,
    createProduct,
    updateProduct,
    removeProduct,
    registerMovement,
    removeMovement,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be inside AppProvider");
  return ctx;
}
